import { useRuntimeVariables } from 'app-kit'
import { AuthedAxiosRequests, useGeckoAuth } from 'features/auth'
import React from 'react'

export interface SendSlackMessageRequest {
  channel_id: string
  site_name: string
  unit_name: string
  component_name: string
  component_slug: string
  inspection_slug: string
  forecast_link: string
  sales_representative: string | undefined
  data_lead: string | undefined
  supervisor: string | undefined
  operations_data_lead: string | undefined
  qa_qc_lead: string | undefined
}

export function useSlackAPI() {
  const { DS_API_URL } = useRuntimeVariables()
  const { authorizedAxios: axios } = useGeckoAuth()

  return React.useMemo(() => {
    return {
      getSlackChannels: () => getSlackChannels(DS_API_URL, axios),
      getSlackUsers: () => getSlackUsers(DS_API_URL, axios),
      sendSlackNotification: (slug: string, request: SendSlackMessageRequest) =>
        sendSlackNotification(slug, DS_API_URL, axios, request),
    }
  }, [DS_API_URL, axios])
}

async function getSlackChannels(dsApiUrl: string, axios: AuthedAxiosRequests) {
  return await axios.get(`${dsApiUrl}/api/v1/inspections/get-slack-channels`, {
    headers: { 'Content-Type': 'application/json' },
  })
}

async function getSlackUsers(dsApiUrl: string, axios: AuthedAxiosRequests) {
  return await axios.get(`${dsApiUrl}/api/v1/inspections/get-slack-users`, {
    headers: { 'Content-Type': 'application/json' },
  })
}

async function sendSlackNotification(
  slug: string,
  dsApiUrl: string,
  axios: AuthedAxiosRequests,
  request: SendSlackMessageRequest
) {
  return await axios.post(
    `${dsApiUrl}/api/v1/inspections/${slug}/send-slack-notification`,
    request,
    { headers: { 'Content-Type': 'application/json' } }
  )
}
